import React from "react";
import { useTranslation } from "react-i18next";
import { universityList } from "@/assets/universityList";

interface StudentUniversityLogosProps {
  codes: string[];
}

/**
 * University marks for the `university` JSON column of an event, using the
 * same bundled logos as the signup form and the landing page.
 */
const StudentUniversityLogos: React.FC<StudentUniversityLogosProps> = ({ codes }) => {
  const { t } = useTranslation();

  if (!codes || codes.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {codes.map((code) => {
        const university = universityList.find((item) => item.value === code);
        if (!university) return null;
        return (
          <img
            key={code}
            src={university.image}
            alt={t(code)}
            title={t(code)}
            className="h-6 w-6 rounded object-contain"
          />
        );
      })}
    </div>
  );
};

export default StudentUniversityLogos;
